export const NO_USER_STORAGE_KEY = 'UsersIndex__no_user'
export const LINXFOUR_MASTER_USER_ID = Number(import.meta.env.VITE_LINXFOUR_MASTER_USER_ID) || 1
export const LINXFOUR_SHORT_NAME = 'Linxfour'

export const PRODUCT_TYPE_NAMES = {
    PPU: 'ppu',
    FIXED: 'fixed',
    SLB: 'slb',
}

export const PLANNED_UTILIZATION_YEARLY_DECIMALS = 2
export const PLANNED_UTILIZATION_MONTHLY_DECIMALS = 6

export const RV_DEPRECIATION_PERIOD_YEARS = [4, 5, 6, 7, 10, 12, 15]
export const DEFAULT_RV_DEPRECIATION_PERIOD_YEARS = 7
export const RV_RESIDUAL_FLOOR = 1
export const RV_CURRENCY_DIGITS = 2
export const DEFAULT_RV_SHARE = 0.6
